import { useContext } from 'react';
import { tableWrappingContext } from './context';
export var useTableWrapping = function () {
    var wrapping = useContext(tableWrappingContext);
    return wrapping;
};
